export default __webpack_public_path__ + "static/py-f38609c1094cd15ede2af634e5efcfdc.svg";